export * from './lib/coenen-app-shell.module';
export * from './lib/coenen-app-shell-routing.module';
